<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
    <div class="mt-3">
        {{ data.message }}
    </div>
    <div class="my-3" *ngIf="data.list">
        <ul class="dialog-list">
            <li *ngFor="let item of data.list">{{ item }}</li>
        </ul>
    </div>
</div>
<div mat-dialog-actions class="d-flex justify-content-between">
    <button mat-button [mat-dialog-close]="false">
        {{ data.noText || 'Cancel' }}
    </button>
    <button
        mat-raised-button
        [mat-dialog-close]="true"
        color="primary"
        cdkFocusInitial
    >
        {{ data.yesText || 'Confirm' }}
    </button>
</div>
